import React from "react";
import styled from "styled-components";
import { colors } from "core/stylesheet";
import Spinner from "../Spinner";

const Wrap = styled.div`
  height: 50vh;
`;

export default () => (
  <Wrap className="flex w-100 h-100 items-center justify-center">
    <Spinner color={colors.brand} />
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/generic/kit/BoxSpinner/index.js